<template>
  <div class="flex h-auto bg-gray-900 text-white">
    <!-- Sidebar -->
    <aside class="w-64 bg-gray-800 p-6 flex flex-col space-y-6 shadow-lg bg-gradient-to-b from-gray-800 to-gray-900 border border-gray-700">
      <div class="flex items-center justify-center space-x-3">
       <img src="@/assets/logo.svg" alt="Vultric Logo" class="h-20">
      </div>
      <Navbar></Navbar>
    </aside>
    
    <!-- Main Content -->
    <div class="flex-1 flex flex-col">
      <header class="h-16 bg-gray-800 flex items-center justify-between px-6 shadow-md bg-gradient-to-b from-gray-800 to-gray-900 border-b border-gray-700">
        <h2 class="text-xl font-semibold">Invoice Details</h2>
        <button @click="$router.push('/billing')" class="p-2 bg-gray-700 rounded-lg hover:bg-blue-500">Back to Invoices</button>
      </header>
      
      <main class="p-6 flex-1">
        <div v-for="invoice in invoice" :key="invoice.id" class="bg-gray-800 p-6 rounded-xl shadow-md">
          <h3 class="text-lg font-semibold mb-4">Invoice #{{ invoice.id }}</h3>
          <div class="grid grid-cols-2 gap-6 border-b border-gray-700 pb-4 mb-5">
            <div>
              <h4 class="font-semibold text-lg">Company Information</h4>
              <p>Syniac</p>
              <p>2942 N 24th St Ste 115 PMB 821864</p>
              <p>Phoenix, AZ, 85016</p>
              <p>Email: support@syniac.com</p>
            </div>
            <div>
              <h4 class="font-semibold text-lg">Billed To</h4>
              <p>{{ user.name }}</p>
              <p>{{ user.address }}</p>
              <p>{{ user.city }}, {{ user.state }} {{ user.zip }}</p>
              <p>Email: {{ user.email }}</p>
            </div>
          </div>
          <p><strong>Date:</strong> {{ invoice.date }}</p>
          <p><strong>Status:</strong> <span :class="{'text-green-400': invoice.status === 'Paid', 'text-red-400': invoice.status !== 'Paid'}">{{ invoice.status }}</span></p>
          <p><strong>Amount:</strong> ${{ invoice.amount }}</p>
          <p><strong>Payment Method:</strong> {{ invoice.paymentHandler }}</p>
          
          <!-- Items Table -->
          <h4 class="text-lg font-semibold mt-4">Purchased Items</h4>
          <div class="overflow-x-auto">
            <table class="w-full bg-gray-700 rounded-lg mt-2">
              <thead>
                <tr class="bg-gray-800 text-left">
                  <th class="p-2">Item</th>
                  <th class="p-2">Quantity</th>
                  <th class="p-2">Price</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in items" :key="item.name" class="border-b border-gray-600">
                  <td class="p-2">{{ item.name }}</td>
                  <td class="p-2">{{ item.quantity }}</td>
                  <td class="p-2">${{ item.price }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          
          <button @click="downloadPDF" class="mt-4 bg-blue-500 p-2 rounded-lg hover:bg-blue-600">Download PDF</button>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import Navbar from '@/components/nav.vue';
import axios from 'axios';
import { jsPDF } from 'jspdf'; // Import jsPDF

export default {
  name: "InvoiceDetails",
  components: { Navbar },
  data() {
    return {
      invoice: [],
      items: [],
      user: {},
    };
  },
  async created() {
    const invoiceId = this.$route.params.id;
    try {
      const response = await axios.get(`https://api.syniac.com:3000/api/invoice/invoice/${invoiceId}`, { withCredentials: true });
      this.invoice = response.data.invoices;
      this.items = response.data.items;
      this.user = response.data.user;
    } catch (error) {
      console.error("Error fetching invoice details:", error);
      if (error.response && (error.response.status === 401 || error.response.status === 403)) {
        this.$router.push('/billing');
      }
    }
  },
  methods: {
    downloadPDF() {
      const invoiceId = this.$route.params.id;
      const doc = new jsPDF();
      doc.setFont("helvetica", "normal");

      // Title
      doc.setFontSize(20);
      doc.text("Invoice # " + invoiceId, 20, 20);

      // Company Information
      doc.setFontSize(12);
      doc.text("Syniac", 20, 30);
      doc.text("2942 N 24th St Ste 115 PMB 821864", 20, 35);
      doc.text("Phoenix, AZ, 85016", 20, 40);
      doc.text("Email: support@syniac.com", 20, 45);

      // Billed To
      doc.text("Billed To:", 20, 55);
      doc.text(this.user.name, 20, 60);
      doc.text(this.user.address, 20, 65);
      doc.text(`${this.user.city}, ${this.user.state} ${this.user.zip}`, 20, 70);
      doc.text(`Email: ${this.user.email}`, 20, 75);

      // Invoice Info
      doc.text(`Date: ${this.invoice["0"].date}`, 20, 85);
      doc.text(`Status: ${this.invoice["0"].status}`, 20, 90);
      doc.text(`Amount: $${this.invoice["0"].amount}`, 20, 95);

      // Items Table
      doc.text("Purchased Items:", 20, 105);
      let y = 115;
      this.items.forEach(item => {
        doc.text(`${item.name} - $${item.price} x ${item.quantity} = $${item.price * item.quantity}`, 20, y);
        y += 5;
      });
     doc.save("invoice.pdf");
    }
  }
};
</script>
